export default __webpack_public_path__ + "static/media/leaves.44852ce7.png";